function updateCartCountBadges() {
  fetch(`${routes.cart_url}.js`)
    .then((res) => res.json())
    .then((cart) => {
      const variantCounts = {};
      cart.items.forEach((item) => {
        variantCounts[item.variant_id] = (variantCounts[item.variant_id] || 0) + item.quantity;
      });
      document.querySelectorAll('[data-cart-count-for-variant]').forEach((badge) => {
        const variantId = badge.dataset.cartCountForVariant;
        const count = variantCounts[variantId] || 0;
        const numberEl = badge.querySelector('.quick-add__cart-count-number');
        if (numberEl) numberEl.textContent = count;
        badge.setAttribute('aria-label', `${count} items in cart`);
        badge.classList.toggle('quick-add__cart-count--has-items', count > 0);
      });
    });
}

subscribe(PUB_SUB_EVENTS.cartUpdate, updateCartCountBadges);

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      for(const [key, value] of formData.entries()) {
        if(key === 'quantity') {
          const quantity = document.querySelector("quantity-input input.quantity__input");
          if(quantity) {
            const qty_to_add = parseInt(quantity.getAttribute("value") ?? value);
            const qty_in_form = parseInt(value);

            if(qty_in_form !== qty_to_add) {
              formData.set("quantity", qty_to_add);
            }
          }
        }
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if(this.form.classList.contains("target_drawer")) {
            if (typeof window.upcartOpenCart === "function") window.upcartOpenCart();
          } else if(this.form.classList.contains("target_checkout")) {
            location.href = '/checkout';
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-open-cart-drawer]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (cartIcon) cartIcon.click();
});

const cartBubble = document.querySelector('.cart-count-bubble');
if (cartBubble) {
  new MutationObserver(updateCartCountBadges).observe(cartBubble, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}
